import React, { useId, useState } from 'react';

export default function WellwiredDisclosure({ title, label, className = '', children }) {
  const [open, setOpen] = useState(false);
  const id = useId();

  return (
    <div className={`ww-disclosure ${className}`}>
      <button
        type="button"
        className="ww-disclosure-toggle"
        aria-label={label}
        aria-expanded={open}
        aria-controls={id}
        onClick={() => setOpen(previous => !previous)}
      >
        {title}
        <span className="ww-plus" aria-hidden="true" />
      </button>
      <div id={id} className="ww-disclosure-panel" aria-hidden={!open}>
        <div className="ww-disclosure-content">{children}</div>
      </div>
    </div>
  );
}
